import React from 'react'

export default ({ onClick, text, marginTop, marginBottom, mode = 0, marginLeft }) => (<div className={mode === 0 ? "create-conference-btn-container" : "create-conference-btn-container1"} style={{ marginTop, marginBottom, marginLeft }} >
    <button onClick={onClick} className="btn" style={{ fontSize: 18 }} >
        {text}
    </button></div>)


// WEBPACK FOOTER //
// ./src/components/Regular/CreateBtn.js